import Proxy from '../Proxy';

class TelegramBotUserProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('telegram-bot/user', parameters);
  }
}

export default TelegramBotUserProxy;
